import { useState, useEffect } from 'react';
import { Dropdown, FormControl } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useIsFirstRender } from '../../../../hooks/isFirstRender';
import { AppRemixIcon } from '@/layout/AppComponents';

export default function InputTranslatable(props) {
  const {
    disabled,
    onChange,
    autofocus,
    append,
    prepend,
    autoFocus = false,
    className = 'mb-3',
    values = {},
    placeholder = '',
    onKeyUp = () => {},
  } = props;
  const { moduleBridgeHex } = useParams();
  const isFirstRender = useIsFirstRender();
  const actualLang = useSelector((state) => state.global.urlData.lang);
  //   const languages = useSelector((state) => state.global.languages);
  const languages = useSelector((state) => state.module?.[moduleBridgeHex]?.lang);
  const [newValues, setNewValues] = useState(values);
  const [selectedLanguage, setSelectedLanguage] = useState(actualLang);

  const handleOnChange = (input, langSlug) => {
    if (input.target.value) {
      const newLang = { ...newValues };
      newLang[langSlug] = input.target.value;
      setNewValues(newLang);
    } else {
      const { [langSlug]: removed, ...newValuesWithoutEmptySlug } = newValues;
      setNewValues(newValuesWithoutEmptySlug);
    }
  };

  useEffect(() => {
    if (!isFirstRender) onChange(newValues);
  }, [newValues]);

  useEffect(() => {
    setNewValues(values);
  }, [values]);

  return (
    <>
      {selectedLanguage && languages && (
        <div className={`input-group ${className}`}>
          {prepend &&
            prepend.map((p, i) => (
              <div className="input-group-prepend" key={i}>
                {p}
              </div>
            ))}
          <FormControl
            placeholder={`[${selectedLanguage.toUpperCase()}] ${placeholder}`}
            value={newValues[selectedLanguage] || ''}
            onChange={(input) => handleOnChange(input, selectedLanguage)}
            onKeyUp={(e) => onKeyUp(e)}
            autoFocus={autofocus}
          />
          <div className="input-group-append">
            <Dropdown as="div" className="dropdown" align="end">
              <Dropdown.Toggle
                as="button"
                variant="outline-info"
                id=""
                className="btn btn-info z-index-initial"
              >
                {selectedLanguage}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <div style={{ maxHeight: '250px', overflow: 'auto' }}>
                  {languages.map((l, i) => (
                    <Dropdown.Item
                      key={i}
                      active={l.slug === selectedLanguage}
                      onClick={() => setSelectedLanguage(l.slug)}
                    >
                      {l.name}{' '}
                      {newValues[l.slug] && (
                        <AppRemixIcon className="ml-1" icon="check" />
                      )}
                    </Dropdown.Item>
                  ))}
                </div>
              </Dropdown.Menu>
            </Dropdown>
          </div>
          {append &&
            append.map((a, i) => (
              <div className="input-group-append" key={i}>
                {a}
              </div>
            ))}
        </div>
      )}
    </>
  );
}
